import React, { useState } from 'react';
import { Share2, Linkedin, Facebook, MessageCircle, Twitter, Link, Check } from 'lucide-react';

const NETWORKS = {
  linkedin: {
    label: 'LinkedIn',
    icon: Linkedin,
    color: '#0077b5',
    url: (text, link) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}&summary=${encodeURIComponent(text)}`
  },
  facebook: {
    label: 'Facebook',
    icon: Facebook,
    color: '#1877f2',
    url: (text, link) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&quote=${encodeURIComponent(text)}`
  },
  whatsapp: {
    label: 'WhatsApp',
    icon: MessageCircle,
    color: '#25d366',
    url: (text, link) => `https://api.whatsapp.com/send?text=${encodeURIComponent(text + ' ' + link)}`
  },
  twitter: {
    label: 'X',
    icon: Twitter,
    color: '#e7e9ea',
    url: (text, link) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(link)}`
  }
};

export default function ShareButtons({
  url,
  message,
  networks = ['linkedin', 'facebook', 'whatsapp', 'twitter'],
  label = 'Partager',
  compact = false
}) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const fullUrl = url || window.location.href;

  const handleShare = (networkKey) => {
    const net = NETWORKS[networkKey];
    if (!net) return;
    window.open(net.url(message || '', fullUrl), '_blank', 'width=600,height=400,noopener');
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        {networks.map(key => {
          const net = NETWORKS[key];
          if (!net) return null;
          const Icon = net.icon;
          return (
            <button
              key={key}
              onClick={() => handleShare(key)}
              className="w-8 h-8 rounded-lg flex items-center justify-center hover:scale-110 transition-transform"
              style={{ backgroundColor: net.color + '20' }}
              title={net.label}
            >
              <Icon size={14} style={{ color: net.color }} />
            </button>
          );
        })}
        <button
          onClick={handleCopy}
          className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center hover:scale-110 transition-transform"
          title="Copier le lien"
        >
          {copied ? <Check size={14} className="text-[#06d6a0]" /> : <Link size={14} className="text-[#a0a0ab]" />}
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 text-sm text-[#a0a0ab] hover:text-white transition-colors bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-3 py-2"
        data-testid="share-btn"
      >
        <Share2 size={14} />
        {label}
      </button>
      {open && (
        <div className="absolute bottom-full mb-2 left-0 bg-[#1a1a2e] border border-white/10 rounded-2xl p-3 shadow-2xl z-50 min-w-[180px]">
          <p className="text-xs text-[#a0a0ab] mb-2 font-medium">Partager sur</p>
          <div className="space-y-1">
            {networks.map(key => {
              const net = NETWORKS[key];
              if (!net) return null;
              const Icon = net.icon;
              return (
                <button
                  key={key}
                  onClick={() => { handleShare(key); setOpen(false); }}
                  className="w-full flex items-center gap-2.5 text-xs text-[#e8e8e8] hover:text-white hover:bg-white/5 rounded-lg px-2 py-1.5 transition-colors"
                >
                  <Icon size={14} style={{ color: net.color }} />
                  {net.label}
                </button>
              );
            })}
            <button
              onClick={() => { handleCopy(); setOpen(false); }}
              className="w-full flex items-center gap-2.5 text-xs text-[#e8e8e8] hover:text-white hover:bg-white/5 rounded-lg px-2 py-1.5 transition-colors"
            >
              {copied ? <Check size={14} className="text-[#06d6a0]" /> : <Link size={14} className="text-[#a0a0ab]" />}
              {copied ? 'Copié !' : 'Copier le lien'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
